import {
    FormGroup,
    Label,
    Input,
    Spinner
} from 'reactstrap';
export default function SingleUserSection({ modalData, handleChange, validationErrors, disableEmail, handleEmailBlur, isEmailInUse, isEmailFetchLoading }) {
    return (
        <>
            <FormGroup className={validationErrors.fName ? 'mb-0' : 'mb-3'}>
                <div className="d-flex align-items-center mb-1">
                    <Label
                        for="firstName"
                        className="me-3 mb-0"
                        style={{ minWidth: '130px' }}
                    >
                        First Name *
                    </Label>
                    <div className="w-100">
                        <Input
                            id="firstName"
                            name="fName"
                            value={modalData.userData.fName}
                            className="form-control-sm"
                            placeholder="First"
                            onChange={handleChange}
                            invalid={!!validationErrors.fName}
                        />
                        {validationErrors.fName && (
                            <div className="text-danger small mt-1">
                                {validationErrors.fName}
                            </div>
                        )}
                    </div>
                </div>
            </FormGroup>
            <FormGroup className={validationErrors.lName ? 'mb-0' : 'mb-3'}>
                <div className="d-flex align-items-center mb-1">
                    <Label for="lastName" className="me-3 mb-0" style={{ minWidth: '130px' }}>
                        Last Name *
                    </Label>
                    <div className="w-100">
                        <Input
                            id="lastName"
                            className="form-control-sm"
                            name="lName"
                            value={modalData.userData.lName}
                            placeholder="Last"
                            onChange={handleChange}
                            invalid={!!validationErrors.lName}
                        />
                        {validationErrors.lName && (
                            <div className="text-danger small mt-1">{validationErrors.lName}</div>
                        )}
                    </div>
                </div>
            </FormGroup>

            <FormGroup className={validationErrors.email ? 'mb-0' : 'mb-3'}>
                <div className="d-flex align-items-center mb-1">
                    <Label for="email" className="me-3 mb-0" style={{ minWidth: '130px' }}>
                        Email *
                    </Label>
                    <div className="w-100">
                        {!isEmailFetchLoading &&
                            <Input
                                className="form-control-sm"
                                id="email"
                                name="email"
                                value={modalData.userData.email}
                                placeholder="Email"
                                onChange={handleChange}
                                onBlur={handleEmailBlur}
                                invalid={!!validationErrors.email}
                                disabled={disableEmail}
                                data-testid="email-input"
                            />
                        }
                        {isEmailFetchLoading && <Spinner></Spinner>}
                        {(!isEmailFetchLoading && !isEmailInUse && !disableEmail && modalData.userData.email !== "") && (<div className="text-success small mt-1">^ New User</div>)}
                        {(!isEmailFetchLoading && isEmailInUse && !disableEmail && modalData.userData.email !== "") && (<div className="text-danger small mt-1">^ Existing User (must retain current user role)</div>)}
                    </div>
                </div>
            </FormGroup>
        </>
    )
}